import { render, staticRenderFns } from "./PageCustomDashboard.vue?vue&type=template&id=888e4a1e&scoped=true"
import script from "./PageCustomDashboard.vue?vue&type=script&lang=js"
export * from "./PageCustomDashboard.vue?vue&type=script&lang=js"
import style0 from "./PageCustomDashboard.vue?vue&type=style&index=0&id=888e4a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888e4a1e",
  null
  
)

export default component.exports